module.exports = __webpack_public_path__ + "img/fittingRoom.c2803ddd.webp";